import React from 'react';
import Button from '../../components/button';

function Playground() {
  return (
    <div>
      <Button color="primary" size="large" label="Hire Me" />
      <Button color="secondary" size="medium" label="Send message" />
    </div>
  );
}

export default Playground;
